import { useEffect } from "react";

const Download = () => {
  useEffect(() => {
    window.location.href = "/Android-APK/app-release.apk";
  }, []);

  return <h3>Downloading APK...</h3>;
};

export default Download;